<template>
	<div>
		转账
	</div>
</template>
<script>
	export default {
		components: {},
		data() {
			return {}
		},
		methods: {},
		mounted() {}
	};
</script>
<style lang='scss' scoped>
</style>
